import sendEmailForm from './signup_send_email_form_selector'
import signupMetrics from './signup_metrics_selector'
import signupTeacher from './signup_teacher_selector'
import signupBase from './signup_base_selector'

export default {
	sendEmailForm,
	signupMetrics,
	signupTeacher,
	signupBase,
}
